// /features/juegoFechas/hooks/useJuegoFechas.ts
import { useState } from 'react';
import { DiasSemana } from '../constants/diasSemana';
import { getRandomDateIn, obtenerDiaDeLaSemana } from '../utils';

interface Pregunta {
  fecha: Date;
  opcionCorrecta: DiasSemana;
  inputUsuario: DiasSemana | null;
}

export const useJuegoFechas = () => {
  const [limit2025, setLimit2025] = useState(false);
  const [loading] = useState(false);
  const [etapa, setEtapa] = useState(0);
  const [preguntas, setPreguntas] = useState<Pregunta[]>([]);
  const [indice, setIndice] = useState(-1);
  const [correctas, setCorrectas] = useState(0);
  const [tiempoMemoria, setTiempoMemoria] = useState(0);

  const iniciarJuego = (limit: boolean) => {
    setLimit2025(limit);
    setPreguntas([]);
    setIndice(-1);
    setCorrectas(0);
    setEtapa(1);
    CrearNuevaPregunta(limit);
  };

  const CrearNuevaPregunta = (limit: boolean) => {
    const desde = new Date(limit ? 2025 : 1600, 0, 1);   // o 2024 si quieres
    const hasta = new Date(limit ? 2025 : 2099, 11, 31);

    const fecha = getRandomDateIn(desde, hasta);
    const nuevaPregunta: Pregunta = {
      fecha,
      opcionCorrecta: obtenerDiaDeLaSemana(fecha),
      inputUsuario: null,
    };

    setPreguntas((prev) => {
      const updated = [...prev, nuevaPregunta];
      // el índice siempre es la última
      setIndice(updated.length - 1);
      return updated;
    });
  };

  const handleSelectDia = (input: DiasSemana) => {
    setPreguntas((prev) => {
      if (indice < 0 || indice >= prev.length) return prev;

      const updated = [...prev];
      const actual = updated[indice];

      // Si ya tenía respuesta, no contamos de nuevo (protege de dobles llamadas)
      if (actual.inputUsuario !== null) {
        return prev;
      }

      const esCorrecta = input === actual.opcionCorrecta;

      updated[indice] = {
        ...actual,
        inputUsuario: input,
      };

      if (esCorrecta) {
        setCorrectas((c) => c + 1); // ✅ suma segura
      }

      return updated;
    });

    // Generar la siguiente pregunta
    CrearNuevaPregunta(limit2025);
  };

  const HandleTiempo = () => {
    if (etapa === 1) {
      setEtapa(2);
    } else {
      throw new Error('tiempo iniciado fuera de lugar');
    }
  };

  const reiniciarJuego = () => {
    setEtapa(0);
    setPreguntas([]);
    setIndice(-1);
    setCorrectas(0);
  };

  const resultadoFinal =
    correctas >= 5 ? '¡FELICITACIONES!' : '¡BUEN INTENTO!';

  return {
    etapa,
    preguntas,
    indice,
    loading,
    correctas,
    iniciarJuego,
    handleSelectDia,
    reiniciarJuego,
    resultadoFinal,
    setTiempoMemoria,
    HandleTiempo,
  };
};
